import { Get_All_Top_Saler_by_monthyear, Get_Error } from '../Types';

const initialState = {
  salesperformansmonthandyear: [],
};

const SalesPerformanceReduce = (state = initialState, action) => {
  // console.log("🔥 Reducer Action:", action); // ✅ تحقق مما إذا كان الـ Reducer يُستدعى أم لا

  switch (action.type) {
    case Get_All_Top_Saler_by_monthyear:
      return {
        ...state,
        salesperformansmonthandyear: action.payload || [], // ✅ تأكد أن البيانات ليست `undefined`
        loading: false,
      };

    case Get_Error:
      return {
        ...state,
        error: action.payload || 'Unknown error',
        loading: false,
      };
    default:
      return state;
  }
};

export default SalesPerformanceReduce;
